import { useRef, useState } from "react"

import Button from "../../../common/Button"
import { useDispatch, useSelector } from "react-redux"
import { updateUploadedDocument } from "../../../../lib/fetchApi"
import { caseActions } from "../../../../store/case"
import { notificationActions } from "../../../../store/notifications"
import BodySimpleModalV3 from "../../../common/modal/BodySimpleModalV3"
import { formatDate } from "../../../../lib/script"
import { validateBoxUploadFile } from "../../../../lib/docs"

const UpdateDocument = ({document}) => {

    const inputRef = useRef(null)
    const dispatch = useDispatch()
    const user = useSelector(state => state.user.user)
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    const [isLoading, setIsLoading] = useState(false)

    const onFileDrop = async (e) => {
        setIsLoading(true)
        try {
            if (e.target.files.length > 0) {
                const selectedFile = e.target.files[0]
                const sizeError = validateBoxUploadFile(selectedFile)
                if (sizeError) {
                    dispatch(notificationActions.setError({ errorMessage: `"${selectedFile.name}" is too large. ${sizeError}` }))
                    e.target.value = ''
                    return
                }

                let filesArray = [{
                        id: `${selectedFile.name}-${selectedFile.size}-${selectedFile.lastModified}-${Date.now()}`,
                        file: selectedFile.name,
                        file_to_upload: selectedFile,
                        dateuploaded: formatDate(new Date()),
                        uploader: user.name,
                        type: null,
                        notes: 'same as type, no notes!'
                    }]


                let formData = new FormData()
                formData.append("file", filesArray[0].file_to_upload);

                const update = await updateUploadedDocument(userToken, activeCase.case.id, document.id, formData)

                if (update?.errorMessage) {
                    dispatch(notificationActions.setError(update))  
                } else {
                    dispatch(caseActions.replaceItemInDocuments(update))
                }
            }
        } finally {
            setIsLoading(false)
        }

	}

    const updateDocumentHandler = () => {
        inputRef.current.click()
    }
    return <>
        <input ref={inputRef} type="file" value="" onChange={onFileDrop} name="update_uploaded_document" id="update_uploaded_document" style={{display: 'none'}}/>

        {/* btnStyle={'btn_text'} */}
        <BodySimpleModalV3 message={'Update document'}>
            <Button btnStyle={'btn_small_icon'} click={updateDocumentHandler} isLoading={isLoading} loaderType={'dark'}>
                <i className="ti ti-upload"></i>
                {/* Update */}
            </Button>
        </BodySimpleModalV3>
        
        {/* <BodySimpleModalV3 message={'Update document'}>
            <Button btnStyle={'btn_simple'} click={updateDocumentHandler} isLoading={isLoading} loaderType={'dark'}><i className="ti ti-upload"></i></Button>
        </BodySimpleModalV3> */}
    </>
}

export default UpdateDocument